import { Button, Divider, Input, Modal, Select, Table, TableProps } from "antd";
import { useEffect, useState } from "react";
import { StaffsModel } from "../../../models/staffsModel";
import { allEducationLevelOptions, allQuarters, importStaffColumns } from "../../../Static/StaffsStatic";

interface IImportStaffModalProps {
    isShowing: boolean;
    allStaffs: StaffsModel[];
    handleClose: () => void;
    action: (idList: string) => Promise<void>;
}

function ImportStaffModal(props: IImportStaffModalProps) {
    const { action, isShowing, handleClose, allStaffs } = props;
    const [idList, setIdList] = useState<string>("");
    const [quartersSelected, setQuartersSelected] = useState<string[]>([]);
    const [data, setData] = useState<StaffsModel[]>([]);
    const [search, setSearch] = useState<string>("");

    function handleChange(value: string[]) {
        setQuartersSelected(value);
    };

    function onSearch(value: any, _e: any, info: any) {
        setSearch(value);
    }

    function listFilter(): StaffsModel[] {
        if (search == "" && quartersSelected.length == 0) {
            return allStaffs;
        }

        var resp = allStaffs.filter(item => quartersSelected.includes(item.period.toString()) || item.name.toLowerCase().includes(search.toLowerCase()) ||
            allEducationLevelOptions[item.educationLevel].label.toLowerCase().includes(search.toLowerCase()) ||
            allQuarters[item.period].label.toLowerCase().includes(search.toLowerCase()));

        if (quartersSelected.length > 0)
            resp = resp.filter(item => quartersSelected.includes(item.period.toString()));

        return resp;
    }

    const rowSelection: TableProps<StaffsModel>['rowSelection'] = {
        onChange: (selectedRowKeys: React.Key[], selectedRows: StaffsModel[]) => {
            const ids: string[] = [];
            selectedRows.forEach(staff => ids.push(staff.id));

            setIdList(ids.join(","));
        },
    };

    useEffect(() => {
        setData(allStaffs);
    }, [allStaffs]);

    useEffect(() => {
        setData(listFilter());
    }, [search, quartersSelected]);

    return (
        <Modal
            title="Importar Funcionários do Ano Anterior"
            open={isShowing}
            width={1000}
            onCancel={handleClose}
            footer={null}
        >
            <Divider />
            <div className="d-flex w-100 align-items-end mb-4">
                <div className="d-flex w-50 me-2 flex-column">
                    <label>Período</label>
                    <Select
                        mode="multiple"
                        allowClear
                        size="large"
                        value={quartersSelected}
                        placeholder="Selecione uma ou mais opções"
                        onChange={handleChange}
                        options={allQuarters}
                    />
                </div>
                <Input.Search size="large" className="w-50 ms-2" placeholder="Pesquisar" allowClear onSearch={onSearch} style={{ width: 200 }} />
            </div>
            <Table
                rowSelection={{ type: "checkbox", ...rowSelection }}
                columns={importStaffColumns}
                dataSource={data}
                rowKey={record => record.id}
                scroll={{ x: 'max-content' }}
            />
            <div className='w-100 d-flex align-items-center mt-4'>
                <Button key="cancel" onClick={handleClose} className='w-50 me-1'>
                    Cancelar
                </Button>
                <Button key="submit" type="primary" disabled={idList.length == 0} onClick={() => action(idList)} className='w-50 ms-1 btn-insert-excel'>
                    Salvar
                </Button>
            </div>
        </Modal>
    )
}

export default ImportStaffModal;